import {Component, OnInit, inject} from '@angular/core';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {TranslationService} from '../../core/services/translation.service';
import {HupSubscription} from '../../data/models/subscription.model';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import {GeneralErrorsComponent} from '../../core/components/general-errors/general-errors.component';
import {LoadingSpinnerComponent} from '../../core/components/loading-spinner/loading-spinner.component';
import {DatePipe} from '@angular/common';
import {MatCard, MatCardActions, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {MatButton} from '@angular/material/button';
import {ApplyIfNotEmptyDirective} from '../../core/directives/apply-if-not-empty.directive';

@Component({
  selector: 'app-revocation',
  templateUrl: './revocation.component.html',
  styleUrls: ['./revocation.component.scss'],
  imports: [
    GeneralErrorsComponent,
    LoadingSpinnerComponent,
    MatCard,
    MatCardTitle,
    MatCardSubtitle,
    MatCardActions,
    MatButton,
    DatePipe,
    ApplyIfNotEmptyDirective
  ],
  providers: [DatePipe],
  standalone: true
})
export class RevocationComponent implements OnInit {
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private navigationService = inject(NavigationService);
  translationService = inject(TranslationService);

  isLoadingSub = false;
  subs: HupSubscription[] = [];
  errorsArr: string[] = [];

  ngOnInit(): void {
    this.isLoadingSub = true;
    this.hupSubscriptionsService.getSubscriptions(true).subscribe({
      next: subs => {
        this.isLoadingSub = false;
        // Widerrufbarkeit (Frist, ePaper, laufender Widerruf) entscheidet jetzt das Backend über onlyRevocable=true
        this.subs = subs ?? [];
        if (this.subs.length === 1) {
          this.onNewRevocation(this.subs[0]);
        }
      },
      error: () => {
        this.isLoadingSub = false;
        this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
      }
    });
  }

  onNewRevocation(sub: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.REVOCATIONNEW, [sub.webId + '', sub.backendId + '']);
  }
}
